/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  TemporaryGrant,
  TemporaryGrant$inboundSchema,
} from "./temporarygrant.js";

export type ListTemporaryGrantsResult = {
  /**
   * Temporary grants, soonest deadline first. At most 500 are returned.
   */
  grants: Array<TemporaryGrant>;
};

/** @internal */
export const ListTemporaryGrantsResult$inboundSchema: z.ZodMiniType<
  ListTemporaryGrantsResult,
  unknown
> = z.object({
  grants: z.array(TemporaryGrant$inboundSchema),
});

export function listTemporaryGrantsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListTemporaryGrantsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListTemporaryGrantsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListTemporaryGrantsResult' from JSON`,
  );
}
